export var FETCH_AVAILABILITY = 'STORE_SELECTOR_FETCH_AVAILABILITY';
export var FETCH_AVAILABILITY_DID_YOU_MEAN = 'STORE_SELECTOR_FETCH_AVAILABILITY_DID_YOU_MEAN';
export var FETCH_AVAILABILITY_FAILURE = 'STORE_SELECTOR_FETCH_AVAILABILITY_FAILURE';
export var FETCH_AVAILABILITY_SUCCESS = 'STORE_SELECTOR_FETCH_AVAILABILITY_SUCCESS';
export var FETCH_MORE_AVAILABILITY = 'STORE_SELECTOR_FETCH_MORE_AVAILABILITY';
export var FETCH_MORE_AVAILABILITY_FAILURE = 'STORE_SELECTOR_FETCH_MORE_AVAILABILITY_FAILURE';
export var FETCH_MORE_AVAILABILITY_SUCCESS = 'STORE_SELECTOR_FETCH_MORE_AVAILABILITY_SUCCESS';
export var FETCH_STORES = 'STORE_SELECTOR_FETCH_STORES';
export var FETCH_STORES_FAILURE = 'STORE_SELECTOR_FETCH_STORES_FAILURE';
export var FETCH_STORES_SUCCESS = 'STORE_SELECTOR_FETCH_STORES_SUCCESS';
export var INIT_TRACKING = 'STORE_SELECTOR_INIT_TRACKING';
export var TRACK_CLICK_STORE_DETAILS = 'STORE_SELECTOR_TRACK_CLICK_STORE_DETAILS';
export var TRACK_CLICK_SELECT_STORE = 'STORE_SELECTOR_TRACK_CLICK_SELECT_STORE';
export var TRACK_CLICK_WANT_IT_DELIVERED = 'STORE_SELECTOR_TRACK_CLICK_WANT_IT_DELIVERED';
export var TRACK_CLICK_QUIT = 'STORE_SELECTOR_TRACK_CLICK_QUIT';
export var TRACK_CLICK_FILTER = 'STORE_SELECTOR_TRACK_CLICK_FILTER';
export var TRACK_SEARCH = 'STORE_SELECTOR_TRACK_SEARCH';